import {DEFAULT_AUCTION_COPY} from "./auction-copy";

export const OPEN_AUCTION_BID_STATUS = {
    NONE: 'none',
    LEADING: 'leading',
    OUTBID: 'outbid'
};

export function hasBidAmount(usersBid) {
    return usersBid?.amount !== null && usersBid?.amount !== undefined;
}

function withDefaultLabel(value, fallback) {
    const trimmedValue = typeof value === 'string' ? value.trim() : value;
    return trimmedValue ? trimmedValue : fallback;
}

export function getOpenAuctionBidStatus({
    isAuction,
    status,
    usersBidAmount,
    highestBidAmount
}) {
    if (!isAuction || status !== 'open') {
        return OPEN_AUCTION_BID_STATUS.NONE;
    }

    if (usersBidAmount === null || usersBidAmount === undefined) {
        return OPEN_AUCTION_BID_STATUS.NONE;
    }

    const normalisedUsersBidAmount = Number(usersBidAmount);
    const normalisedHighestBidAmount = highestBidAmount === null || highestBidAmount === undefined
        ? 0
        : Number(highestBidAmount);

    if (!Number.isFinite(normalisedUsersBidAmount)) {
        return OPEN_AUCTION_BID_STATUS.NONE;
    }

    return normalisedUsersBidAmount >= (Number.isFinite(normalisedHighestBidAmount) ? normalisedHighestBidAmount : 0)
        ? OPEN_AUCTION_BID_STATUS.LEADING
        : OPEN_AUCTION_BID_STATUS.OUTBID;
}

export function getAuctionReserveMetLabel(salesEvent) {
    return withDefaultLabel(salesEvent?.reserveMetLabel, DEFAULT_AUCTION_COPY.reserveMetLabel);
}

export function getAuctionOpenBidStatusLabel(openBidStatus, salesEvent) {
    switch (openBidStatus) {
        case OPEN_AUCTION_BID_STATUS.LEADING:
            return withDefaultLabel(salesEvent?.leadingStatusLabel, DEFAULT_AUCTION_COPY.leadingStatusLabel);
        case OPEN_AUCTION_BID_STATUS.OUTBID:
            return withDefaultLabel(salesEvent?.outbidStatusLabel, DEFAULT_AUCTION_COPY.outbidStatusLabel);
        default:
            return null;
    }
}

export function getAuctionOpenBidHelperText(openBidStatus, salesEvent) {
    switch (openBidStatus) {
        case OPEN_AUCTION_BID_STATUS.LEADING:
            return withDefaultLabel(salesEvent?.leadingHelperText, DEFAULT_AUCTION_COPY.leadingHelperText);
        case OPEN_AUCTION_BID_STATUS.OUTBID:
            return withDefaultLabel(salesEvent?.outbidHelperText, DEFAULT_AUCTION_COPY.outbidHelperText);
        default:
            return null;
    }
}

export function getAuctionBidCtaLabel({isAuction, hasUsersBid, openBidStatus, saleMethod}) {
    if (!isAuction) {
        return saleMethod?.toLowerCase() === 'tender' ? 'Make Offer' : 'Place Bid';
    }

    if (!hasUsersBid) {
        return 'Place Bid';
    }

    return openBidStatus === OPEN_AUCTION_BID_STATUS.OUTBID ? 'Bid Again' : 'Increase Bid';
}
